const doc = [({"en":({"js":({"admin":({"highscore_communes":({"table":({"the_commune_was_removed_from_the_highscore":"The commune was removed from the highscore"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;